import { takeLatest } from 'redux-saga/effects';
import { FETCH_BILLED_PACKAGES } from '../../redux/modules/billedMedicalPackage/billedMedicalPackage-actions';
import fetchBilledPackagesWorker from './billedMedicalPackageWorkerSaga';

function* fetchBilledPackagesWatcher() {
    yield takeLatest(FETCH_BILLED_PACKAGES, fetchBilledPackagesWorker);
}

export default fetchBilledPackagesWatcher;
